var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 11.8971C11.7596 11.8971 13.4989 11.4148 13.6668 9.47904C13.6668 7.54456 12.4543 7.66896 12.4543 5.29544C12.4543 3.44146 10.697 1.33203 8.00016 1.33203C5.30334 1.33203 3.54606 3.44146 3.54606 5.29544C3.54606 7.66896 2.3335 7.54456 2.3335 9.47904C2.50213 11.4222 4.24135 11.8971 8.00016 11.8971Z",
    stroke: "#23273B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5929 13.9023C8.68348 14.9122 7.2648 14.9241 6.34668 13.9023",
    stroke: "#23273B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.e3d3d251c9e45f489ecae69773c4dba2.svg";
export { ForwardRef as ReactComponent };